import stripTags from 'striptags'

export const MergeMixins = {
    data() {
        return {
            hasTextCells: [],
            mergeHasTextCells: null,
            mergeCellsModal: {
                active: false,
            },
            isMergeable: false,
        }
    },
    computed: {
        canUnmerge() {
            const firstCell = this.getFirstCell()
            if (this.inputItem.row && this.inputItem.col && firstCell && firstCell.style) {
                return firstCell.style.row_span > 1 || firstCell.style.col_span > 1
            }
            return false
        },
        selectedColumnsLength() {
            return this.selectedColumns?.length
        },
        hasSelectedColumnOptions() {
            return this.selectedColumns?.length > 0
        },
    },
    methods: {
        checkIfMergableCells() {
            if (this.selectedCells.length) {
                if (this.selectedCells.length === 1 && this.selectedCells[0].columns.length === 1) return false
                let isRowsMergeable = this.ifRowMergable()
                let isColsMergeable = false
                if (isRowsMergeable) {
                    isColsMergeable = this.ifColMergable()
                }
                this.isMergeable = isRowsMergeable && isColsMergeable
            } else {
                this.isMergeable = false
            }
        },
        handleBeforeCellsMerge() {
            this.hasTextCells = []
            if (this.selectedCells.length > 0) {
                this.addSelectedCellsToTextCells()
            }

            if (this.hasSelectedColumnOptions) {
                this.addColumnCellsToTextCells()
            }

            if (this.activeCellRow) {
                this.addRowCellsToTextCells()
            }

            if (this.hasTextCells.length) {
                this.mergeCellsModal.active = true
            } else {
                this.handleMergeCells(null)
            }
        },
        addRowCellsToTextCells() {
            this.itemData.table_data[this.activeCellRow - 1].cells.forEach((cell, index) => {
                if (stripTags(cell.term)) {
                    this.hasTextCells.push({
                        row: this.activeCellRow - 1,
                        col: index,
                    })
                }
            })
        },
        addColumnCellsToTextCells() {
            this.selectedColumns.forEach((column) => {
                const colIndex = column - 1
                this.itemData.table_data.forEach((row, index) => {
                    const cell = row.cells[colIndex]
                    if (stripTags(cell.term)) {
                        this.hasTextCells.push({
                            row: index,
                            col: colIndex,
                        })
                    }
                })
            })
        },
        addSelectedCellsToTextCells() {
            for (let i = 0; i < this.selectedCells.length; i++) {
                for (let j = 0; j < this.selectedCells[i].columns.length; j++) {
                    if (
                        stripTags(
                            this.itemData.table_data[this.selectedCells[i].row - 1].cells[
                                this.selectedCells[i].columns[j] - 1
                            ].term,
                        )
                    ) {
                        this.hasTextCells.push({
                            row: this.selectedCells[i].row - 1,
                            col: this.selectedCells[i].columns[j] - 1,
                        })
                    }
                }
            }
        },
        /**
         * Handles 'keepAll','keepFirst' and 'removeAll'
         * @param {String} status
         */
        cellMergeTextStatus(status) {
            let text = ''
            switch (status) {
                case 'keepAll':
                    text = this.concatenateCellTexts()
                    this.clearTextCells()
                    break
                case 'keepFirst':
                    text = this.selectFirstCellText()
                    this.clearTextCells()
                    break
                case 'removeAll':
                    this.clearTextCells()
                    break
                default:
                    break
            }
            this.mergeCellsModal.active = false
            this.handleMergeCells(text)
        },
        handleMergeCells(mergedText = '') {
            let headRowIndex = 0
            let headColIndex = 0
            if (this.activeCellRow) {
                this.itemData.table_data[this.activeCellRow - 1].cells[0].style.col_span =
                    this.itemData.table_data[this.activeCellRow - 1].cells.length
                if (mergedText !== null) this.itemData.table_data[this.activeCellRow - 1].cells[0].term = mergedText
                for (let i = 1; i < this.itemData.table_data[this.activeCellRow - 1].cells.length; i++) {
                    this.itemData.table_data[this.activeCellRow - 1].cells[i].disabled = true
                    this.itemData.table_data[this.activeCellRow - 1].cells[i].style.margin_left = 0
                }
            } else if (this.selectedCells.length > 0 && this.checkIfMergableCells) {
                headRowIndex = this.selectedCells[0].row - 1
                headColIndex = this.selectedCells[0].columns[0] - 1
                if (this.selectedCells.length === 1) {
                    if (this.selectedCells[0].columns.length > 1) {
                        this.itemData.table_data[this.selectedCells[0].row - 1].cells[
                            this.selectedCells[0].columns[0] - 1
                        ].style.col_span = this.selectedCells[0].columns.length
                        if (mergedText !== null)
                            this.itemData.table_data[this.selectedCells[0].row - 1].cells[
                                this.selectedCells[0].columns[0] - 1
                            ].term = mergedText

                        for (let i = 1; i < this.selectedCells[0].columns.length; i++) {
                            const newData = {
                                disabled: true,
                                headRowIndex,
                                headColIndex,
                            }

                            this.mergeCellProperties(
                                this.selectedCells[0].row - 1,
                                this.selectedCells[0].columns[i] - 1,
                                newData,
                            )
                        }
                    }
                } else if (this.selectedCells.length > 1) {
                    let hasMoreCols = this.selectedCells.filter((item) => item.columns.length > 1)
                    if (!hasMoreCols.length) {
                        this.itemData.table_data[this.selectedCells[0].row - 1].cells[
                            this.selectedCells[0].columns[0] - 1
                        ].style.row_span = this.selectedCells.length
                        if (mergedText !== null)
                            this.itemData.table_data[this.selectedCells[0].row - 1].cells[
                                this.selectedCells[0].columns[0] - 1
                            ].term = mergedText
                        for (let i = 1; i < this.selectedCells.length; i++) {
                            const newData = {
                                disabled: true,
                                headRowIndex,
                                headColIndex,
                            }

                            this.mergeCellProperties(
                                this.selectedCells[i].row - 1,
                                this.selectedCells[i].columns[0] - 1,
                                newData,
                            )
                            if (this.selectedCells[i].columns[0] === this.itemData.columns_count) {
                                this.itemData.table_data[this.selectedCells[i].row - 1].cells[
                                    this.selectedCells[i].columns[0] - 1
                                ].style.margin_right = `${this.displayCellMargin}`
                            } else {
                                const currCell =
                                    this.itemData.table_data[this.selectedCells[i].row - 1].cells[
                                        this.selectedCells[i].columns[0]
                                    ]
                                if (currCell.style.margin_left > 0) {
                                    currCell.style.margin_left = `${parseFloat(currCell.style.margin_left) + this.displayCellMargin}`
                                } else currCell.style.margin_left = `${this.displayCellMargin}`
                            }
                        }
                    } else {
                        let columnsCount = this.selectedCells[0].columns.length
                        let rowsCount = this.selectedCells.length
                        for (let i = 0; i < columnsCount; i++) {
                            for (let j = 0; j < this.selectedCells.length; j++) {
                                if (j === 0) {
                                    this.itemData.table_data[this.selectedCells[j].row - 1].cells[
                                        this.selectedCells[j].columns[i] - 1
                                    ].style.row_span = rowsCount
                                    if (i === 0 && mergedText !== null)
                                        this.itemData.table_data[this.selectedCells[j].row - 1].cells[
                                            this.selectedCells[j].columns[i] - 1
                                        ].term = mergedText
                                } else {
                                    const newData = {
                                        disabled: true,
                                        headRowIndex,
                                        headColIndex,
                                    }

                                    this.mergeCellProperties(
                                        this.selectedCells[j].row - 1,
                                        this.selectedCells[j].columns[i] - 1,
                                        newData,
                                    )

                                    if (
                                        !this.itemData.table_data[this.selectedCells[j].row - 1].cells[
                                            this.selectedCells[j].columns[columnsCount - 1]
                                        ]
                                    ) {
                                        this.itemData.table_data[this.selectedCells[j].row - 1].cells[
                                            this.selectedCells[j].columns[columnsCount - 2]
                                        ].style.margin_left = 0
                                        this.itemData.table_data[this.selectedCells[j].row - 1].cells[
                                            this.selectedCells[j].columns[columnsCount - 2]
                                        ].style.margin_right = `${columnsCount * this.displayCellMargin}`
                                    } else {
                                        this.itemData.table_data[this.selectedCells[j].row - 1].cells[
                                            this.selectedCells[j].columns[columnsCount - 1]
                                        ].style.margin_left = `${columnsCount * this.displayCellMargin}`
                                    }
                                }
                            }
                        }

                        this.itemData.table_data[this.selectedCells[0].row - 1].cells[
                            this.selectedCells[0].columns[0] - 1
                        ].style.col_span = columnsCount
                        for (let i = 1; i < columnsCount; i++) {
                            const newData = {
                                disabled: true,
                                headRowIndex,
                                headColIndex,
                            }
                            this.mergeCellProperties(
                                this.selectedCells[0].row - 1,
                                this.selectedCells[0].columns[i] - 1,
                                newData,
                            )
                        }
                    }
                }
                this.selectedCells = []
            } else if (this.hasSelectedColumnOptions) {
                const firstColumnIndex = this.lowestSelectedColumn()
                const selectedColumnLength = this.selectedColumnsLength
                this.selectedColumns.forEach((column) => {
                    const colIndex = column - 1
                    this.itemData.table_data.forEach((row, index) => {
                        let newData = { style: {} }
                        if (colIndex == firstColumnIndex) {
                            if (index == 0) {
                                if (mergedText !== null) newData['text'] = mergedText
                                newData['style']['row_span'] = this.itemData.table_data.length
                            } else {
                                newData['disabled'] = true
                                newData['style']['margin_left'] = `${selectedColumnLength * this.displayCellMargin}`
                            }
                            newData['style']['col_span'] = selectedColumnLength
                        } else {
                            newData['disabled'] = true
                        }
                        this.mergeCellProperties(index, colIndex, newData)
                    })
                })
                this.selectedColumns = []
            }
            this.resetSelections()
            this.isMergeable = false
            this.updateData()
        },
        ifRowMergable() {
            var row = this.selectedCells[0].row + 1
            let isMergeable = true
            for (let i = 1; i < this.selectedCells.length; i++) {
                if (!this.selectedCells.some((item) => item.row === row)) {
                    isMergeable = false
                    break
                } else {
                    row += 1
                }
            }
            return isMergeable
        },
        ifColMergable() {
            let isMergeable = true
            if (this.selectedCells.length > 1) {
                let firstCols = this.selectedCells[0].columns
                for (let i = 1; i < this.selectedCells.length; i++) {
                    if (this.selectedCells[i].columns.length !== firstCols.length) {
                        isMergeable = false
                        break
                    } else {
                        for (let j = 0; j < this.selectedCells[i].columns.length; j++) {
                            if (this.selectedCells[i].columns[j] !== firstCols[j]) {
                                isMergeable = false
                                break
                            } else if (j > 0) {
                                if (this.selectedCells[i].columns[j - 1] + 1 !== this.selectedCells[i].columns[j]) {
                                    isMergeable = false
                                    break
                                }
                            }
                        }
                        if (!isMergeable) {
                            break
                        }
                    }
                }
            } else if (this.selectedCells.length === 1) {
                let col = this.selectedCells[0].columns[0] + 1
                let columns = this.selectedCells[0].columns
                for (let i = 1; i < columns.length; i++) {
                    if (columns[i] === col) {
                        col += 1
                    } else {
                        isMergeable = false
                        break
                    }
                }
            }

            return isMergeable
        },
        sortSelectedCells() {
            this.selectedCells.sort((x, y) => {
                return x.row - y.row
            })
            this.selectedCells.forEach((item) => {
                item.columns.sort((a, b) => {
                    return a - b
                })
            })
        },
        unmergeCells() {
            let firstCell = this.getFirstCell()
            if (!firstCell) return

            const rowSpan = firstCell.style.row_span
            const colSpan = firstCell.style.col_span
            if (rowSpan > 1 && colSpan > 1) {
                for (let i = 0; i < rowSpan; i++) {
                    for (let j = 0; j < colSpan; j++) {
                        let newData = {
                            disabled: false,
                            style: {
                                row_span: 1,
                                col_span: 1,
                                margin_left: 0,
                                margin_right: 0,
                            },
                        }

                        this.mergeCellProperties(this.inputItem.row - 1 + i, this.inputItem.col - 1 + j, newData)
                    }
                    if (this.itemData.table_data[this.inputItem.row - 1 + i].cells[this.inputItem.col + colSpan - 1]) {
                        this.itemData.table_data[this.inputItem.row - 1 + i].cells[
                            this.inputItem.col + colSpan - 1
                        ].style.margin_left = 0
                    }
                }
            } else if (rowSpan === 1 && colSpan > 1) {
                for (let i = 0; i < colSpan; i++) {
                    if (i === 0) {
                        this.itemData.table_data[this.inputItem.row - 1].cells[this.inputItem.col - 1 + i].style.col_span = 1
                    } else {
                        this.itemData.table_data[this.inputItem.row - 1].cells[this.inputItem.col - 1 + i].disabled = false
                        this.itemData.table_data[this.inputItem.row - 1].cells[
                            this.inputItem.col - 1 + i
                        ].style.margin_left = 0
                    }
                }
            } else if (rowSpan > 1 && colSpan === 1) {
                for (let i = 0; i < rowSpan; i++) {
                    if (i === 0) {
                        firstCell.style.row_span = 1
                    } else {
                        const currCell = this.itemData.table_data[this.inputItem.row - 1 + i].cells[this.inputItem.col - 1]
                        currCell.disabled = false
                        if (this.itemData.table_data[this.inputItem.row - 1 + i].cells[this.inputItem.col - 1]) {
                            const prevCell = this.itemData.table_data[this.inputItem.row - 1 + i].cells[this.inputItem.col]
                            prevCell.style.margin_right = this.reduceSingleCellMargin(prevCell.style.margin_right)
                            prevCell.style.margin_left = this.reduceSingleCellMargin(prevCell.style.margin_left)
                        }

                        currCell.style.margin_right = this.reduceSingleCellMargin(currCell.style.margin_right)
                        currCell.style.margin_left = this.reduceSingleCellMargin(currCell.style.margin_left)
                    }
                }
            }
            this.updateData()
        },
        getFirstCell() {
            const row = this.inputItem.row - 1
            const col = this.inputItem.col - 1
            let cell = null
            if (this.itemData.table_data[row] && this.itemData.table_data[row].cells[col]) {
                cell = this.itemData.table_data[row]?.cells[col]
            }

            return cell
        },
        mergeCellProperties(rowIndex, columnIndex, newData) {
            let cell = this.itemData.table_data[rowIndex].cells[columnIndex]

            if (!cell) return

            for (let key in newData) {
                if (!newData.hasOwnProperty(key)) continue

                if (typeof newData[key] === 'object') {
                    // If it's an object, loop through its keys and values
                    for (let childKey in newData[key]) {
                        if (newData[key].hasOwnProperty(childKey)) {
                            cell[key][childKey] = newData[key][childKey]
                        }
                    }
                } else {
                    cell[key] = newData[key]
                }
            }
        },
        toggleSelectAll() {
            this.textAlignment = ''
            this.allCellsSelected = !this.allCellsSelected
            this.clearRowColumnSelection()
            this.clearFocusCell()
        },
        clearRowColumnSelection() {
            this.activeCellRow = null
            this.selectedColumns = []
        },
        concatenateCellTexts() {
            let text = ''
            for (let i = 0; i < this.hasTextCells.length; i++) {
                text += this.itemData.table_data[this.hasTextCells[i].row].cells[this.hasTextCells[i].col].term
            }
            return text
        },
        selectFirstCellText() {
            let text = ''
            const { lowestRow, lowestCol } = this.firstRowColWithText()
            if (this.activeCellRow) {
                text = this.selectCellText(this.activeCellRow - 1, lowestCol)
            } else if (this.selectedCells.length > 0) {
                text = this.selectCellText(lowestRow, lowestCol)
            } else if (this.hasSelectedColumnOptions) {
                const col = this.lowestSelectedColumn()
                text = this.selectCellText(lowestRow, col)
            }
            return text
        },
        selectCellText(row, col) {
            return this.itemData.table_data[row].cells[col]?.term || ''
        },
        lowestSelectedColumn() {
            if (this.selectedColumnsLength == 0) return null

            return this.selectedColumns.sort()[0] - 1
        },
        firstRowColWithText() {
            if (this.hasTextCells.length === 0) return null

            let lowestRow = this.hasTextCells[0].row
            let lowestCol = this.hasTextCells[0].col
            for (let i = 1; i < this.hasTextCells.length; i++) {
                if (this.hasTextCells[i].row < lowestRow) {
                    lowestRow = this.hasTextCells[i].row
                }
                if (this.hasTextCells[i].col < lowestCol) {
                    lowestCol = this.hasTextCells[i].col
                }
            }
            return { lowestRow, lowestCol }
        },
        clearTextCells() {
            for (let i = 0; i < this.hasTextCells.length; i++) {
                this.itemData.table_data[this.hasTextCells[i].row].cells[this.hasTextCells[i].col].term = ''
            }
        },
        checkRowDisabledCells() {
            if (!this.activeCellRow) return
            let isMergeable = true
            this.itemData.table_data[this.activeCellRow - 1].cells.some((cell) => {
                if (cell.disabled) {
                    isMergeable = false
                    return true
                }
            })
            this.isMergeable = isMergeable
        },
        checkColumnsDisabledCells() {
            if (!this.hasSelectedColumnOptions) return
            let isMergeable = true
            this.itemData.table_data.some((row) => {
                this.selectedColumns.some((col) => {
                    if (row.cells[col - 1].disabled) {
                        isMergeable = false
                        return true
                    }
                })
            })
            this.isMergeable = isMergeable
        },
        reduceSingleCellMargin(value) {
            return value - this.displayCellMargin < 0 ? 0 : value - this.displayCellMargin
        },
    },
}
